import { Link, useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

export default function BackToPageCTA({ url, text }) {
  const navigate = useNavigate();

  return (
    <div className="w-100">
      <Link to={url}>
        <div
          style={{
            width: "max-content",
            height: "24px",
            textAlign: "center",
          }}
          className="fs-14 fw-700 fc-black"
          onClick={() => navigate(url)}
        >
          <FiArrowLeft
            color="#000"
            size="24px"
            style={{ marginRight: "10px", marginBottom: "2px" }}
          />
          {text}
        </div>
      </Link>
    </div>
  );
}
